import AppLayout from "../components/common/AppLayout";
import KpiCard from "../components/dashboard/KpiCard";
import AlertasPanel from "../components/dashboard/AlertasPanel";
import VencimientosPanel from "../components/dashboard/VencimientosPanel";
import FlujoCajaChart from "../components/dashboard/FlujoCajaChart";
import GastoCategoriaChart from "../components/dashboard/GastoCategoriaChart";
import useDashboard from "../hooks/useDashboard";
import "../styles/dashboard.css";

export default function DashboardPage() {
    const { data, loading } = useDashboard();

    return (
        <AppLayout title="Dashboard Financiero">
            <div className="dashboard-grid">
                <KpiCard title="Saldo Total" value={data?.saldoTotal} loading={loading} />
                <KpiCard title="Ingresos del Mes" value={data?.ingresosMes} loading={loading} />
                <KpiCard title="Gastos del Mes" value={data?.gastosMes} loading={loading} />
                <KpiCard title="Ahorro Neto" value={data?.ahorroNeto} loading={loading} />
            </div>

            <div className="dashboard-panels">
                <div className="card-panel">
                    <FlujoCajaChart data={data?.flujoCaja || []} />
                </div>
                <div className="card-panel">
                    <GastoCategoriaChart data={data?.gastosCategoria || []} />
                </div>
            </div>

            <div className="dashboard-panels">
                <div className="card-panel">
                    <AlertasPanel items={data?.alertas || []} />
                </div>
                <div className="card-panel">
                    <VencimientosPanel items={data?.vencimientos || []} />
                </div>
            </div>
        </AppLayout>
    );
}